import { FC, useState } from 'react'

import { BitazzaText } from '../../../../components'
import { PerformanceIndexModal } from '../../../MyProfile/components/Performance/Chart/PerformanceIndexModal'
import Styles from './Rules.module.scss'
import { Divider } from 'antd'
import { useTranslation } from 'react-i18next'
import { IMGs } from '../../../../assets/img'
import { RULES_TRANSLATION } from './const'

interface Props {
    onChangeTab: (tab: string) => void
    noMargin?: boolean
    region: 'th' | 'gl'
}

export const Rules: FC<Props> = ({ onChangeTab, noMargin, region }) => {
    const { t } = useTranslation()
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

    const content = RULES_TRANSLATION[region === 'th' ? 'en' : 'gl']

    return (
        <div style={{ marginBottom: noMargin ? '10px' : '120px' }}>
            <PerformanceIndexModal
                isModalOpen={isModalOpen}
                onCLoseModal={() => setIsModalOpen(false)}
            />
            <BitazzaText
                content={t('txt_rules_title')}
                bold
                letterSpacing={2}
                color="#FFFF"
                lineHeight={26}
            />

            <div className={Styles.text}>
                <BitazzaText format="t16" content={content.txt_rule_1} />
                <BitazzaText format="t16" content={content.txt_rule_2} />
                <BitazzaText format="t16" content={content.txt_rule_3} />
                <BitazzaText format="t16" content={content.txt_rule_4} />

                <div>
                    <BitazzaText
                        style={{ paddingLeft: 0 }}
                        display="inline"
                        format="t16"
                        content={content.txt_rule_5}
                    />
                </div>
                <div>
                    <BitazzaText
                        style={{ paddingLeft: 0 }}
                        display="inline"
                        format="t16"
                        content={<>{content.txt_rule_6}</>}
                    />{' '}
                    <BitazzaText
                        display="inline"
                        format="t16"
                        content={t('text_here')}
                        style={{ paddingLeft: 0 }}
                        onClick={() => onChangeTab('tier')}
                    />
                    .
                </div>

                <BitazzaText format="t16" content={content.txt_rule_7} />
                {/* <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '6px',
                        padding: '0',
                        paddingBottom: '8px',
                    }}
                > */}
                {/* <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '6px',
                            padding: 0,
                        }}
                    >
                        <img
                            src={IMGs.bulletPoint}
                            width={8}
                            height={8}
                            style={{ marginTop: '6px' }}
                            alt="bulletPoint"
                        />
                        <BitazzaText
                            format="t16"
                            content="NFT Reward"
                            style={{ textIndent: 'initial' }}
                            bold
                        />
                    </div> */}

                {/* <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '6px',
                            padding: 0,
                        }}
                    >
                        <BitazzaText
                            format="t16"
                            content="1. Bronze: Steampunk Glove"
                            style={{ textIndent: 'initial' }}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '6px',
                            padding: 0,
                        }}
                    >
                        <BitazzaText
                            format="t16"
                            content="2. Silver: Barong Glove"
                            style={{ textIndent: 'initial' }}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '6px',
                            padding: 0,
                        }}
                    >
                        <BitazzaText
                            format="t16"
                            content="3. Gold: Yaksha Glove"
                            style={{ textIndent: 'initial' }}
                        />
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '6px',
                            padding: 0,
                        }}
                    >
                        <BitazzaText
                            format="t16"
                            content="4. Diamond: Tal Glove (grants wearer +0.5% referral income share)"
                            style={{ textIndent: 'initial' }}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '6px',
                            padding: 0,
                        }}
                    >
                        <BitazzaText
                            format="t16"
                            content="5. Master: Oni Glove (grants wearer +1% referral income share)"
                            style={{ textIndent: 'initial' }}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '6px',
                            padding: 0,
                        }}
                    >
                        <BitazzaText
                            format="t16"
                            content="6. Grand Master: Kitsune Glove (grants wearer +2.5% referral income share)"
                            style={{ textIndent: 'initial' }}
                        />
                    </div> */}

                {/* <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '6px',
                            padding: 0,
                        }}
                    >
                        <img
                            src={IMGs.bulletPoint}
                            width={8}
                            height={8}
                            style={{ marginTop: '6px' }}
                            alt="bulletPoint"
                        />
                        <BitazzaText
                            format="t16"
                            content="FDS Prize Pool"
                            style={{ textIndent: 'initial' }}
                            bold
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '6px',
                            padding: 0,
                        }}
                    >
                        <BitazzaText
                            format="t16"
                            content="Top 100 ranked users will receive FDS (Freedom Shards) token from a total prize pool of 5,000 FDS"
                            style={{ textIndent: 'initial' }}
                        />
                    </div>
                </div> */}

                <ol
                    style={{
                        fontSize: '16px',
                        margin: 0,
                        wordBreak: 'break-word',
                    }}
                    type="a"
                >
                    <li>{content.txt_r7_pool}</li>
                    <li>
                        {content.txt_r7_airdrop}
                        {'\n'}
                        {content.txt_r7_what_is}
                        <a
                            onClick={() => {
                                window.open(content.txt_r7_link, '_blank')
                            }}
                            style={{
                                color: '#86a1a1',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                wordBreak: 'break-all',
                            }}
                        >
                            {content.txt_r7_link}
                        </a>
                    </li>
                    <li>{content.txt_r7_note}</li>
                </ol>
                <BitazzaText format="t16" content={content.txt_terms} />
                {region !== 'gl' && (
                    <BitazzaText
                        format="t16"
                        content={content.txt_disclaim_marketing}
                    />
                )}
                <div>
                    <BitazzaText
                        format="t16"
                        content={
                            <span>
                                {content.txt_disclaim_fds}{' '}
                                <a
                                    onClick={() => {
                                        window.open(
                                            'https://bitazza.onelink.me/lhpw/v8pboror',
                                            '_blank'
                                        )
                                    }}
                                    style={{
                                        color: '#86a1a1',
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                        wordBreak: 'break-all',
                                    }}
                                >
                                    {t('text_here')}
                                </a>
                            </span>
                        }
                    />
                </div>
                {region !== 'gl' && (
                    <BitazzaText
                        format="t16"
                        content={content.txt_disclaim_risk}
                    />
                )}

                <BitazzaText format="t16" content={content.txt_rule_8} />

                <Divider className={Styles.divider} />

                <BitazzaText
                    format="t16"
                    content={t('txt_rules_exa_buy_title')}
                    bold
                />
                <BitazzaText format="t16" content={t('tx_r_b_des1')} />

                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText format="t16" content={t('tx_r_b_des2')} />
                </li>
                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText format="t16" content="-30,000USDS" />
                </li>
                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText format="t16" content={t('tx_r_b_des3')} />
                </li>

                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText format="t16" content={t('tx_r_b_des4')} />
                </li>
                <div className={Styles.noIndent}>
                    <BitazzaText format="t16" content={t('tx_r_b_des5')} />
                </div>

                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText
                        format="t16"
                        content="1 BTC (worth 35,000 USDS)"
                    />
                </li>

                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText format="t16" content="-30,000USDS" />
                </li>

                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText format="t16" content={t('tx_r_b_des6')} />
                </li>

                <Divider className={Styles.divider} />
                <BitazzaText
                    format="t16"
                    content={t('txt_rules_exa_sell_title')}
                    bold
                />
                <BitazzaText format="t16" content={t('tx_r_s_des1')} />

                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText
                        format="t16"
                        content="-1 BTC (worth -30,000USDS)"
                    />
                </li>
                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText format="t16" content="-30,000USDS" />
                </li>

                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText format="t16" content={t('tx_r_b_des3')} />
                </li>
                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText format="t16" content={t('tx_r_s_des2')} />
                </li>
                <div className={Styles.noIndent}>
                    <BitazzaText format="t16" content={t('tx_r_s_des3')} />
                </div>

                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText format="t16" content={t('tx_r_s_des4')} />
                </li>
                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText format="t16" content="30,000USDS" />
                </li>

                <li style={{ marginLeft: '8px' }}>
                    <BitazzaText
                        format="t16"
                        content="PNL = 5,000USDS (-25,000 + 30,000)"
                    />
                </li>
            </div>
        </div>
    )
}
